import { createAppKit } from '@reown/appkit/react'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { bsc, mainnet, base } from '@reown/appkit/networks' // Tambah mainnet & base
import { http } from 'viem'

const projectId = 'eadb6d84806ee6c21e4dcdefd90db6ef'

const metadata = {
  name: 'Fabric Foundation',
  description: 'Claim your $ROBO tokens',
  url: 'https://aeryx.com', 
  icons: ['https://cryptologos.cc/logos/bnb-bnb-logo.png']
}

// 1. DAFTARKAN KETIGA JARINGAN
const networks = [bsc, mainnet, base]

export const wagmiAdapter = new WagmiAdapter({
  projectId,
  networks,
  ssr: false,
  // 2. MASUKKAN 3 RPC ANKR KAMU DI SINI
  transports: {
    [bsc.id]: http('https://rpc.ankr.com/bsc/2b782b4c77b0c773ce510807d40f367062ac612116b24d7504b23938b0f2c1d6'), 
    [mainnet.id]: http('https://rpc.ankr.com/eth/2b782b4c77b0c773ce510807d40f367062ac612116b24d7504b23938b0f2c1d6'),
    [base.id]: http('https://rpc.ankr.com/base/2b782b4c77b0c773ce510807d40f367062ac612116b24d7504b23938b0f2c1d6')
  }
})

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  themeMode: 'light',
  featuredWalletIds: [
    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0', 
    '38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662', 
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', 
    'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa', 
    '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4', 
    '0b415a746fb9ee99cce155c2ceca0c6f6061b1dbca2d722b3ba16381d0562150'  
  ],
  features: {
    analytics: true,
    email: false,    
    socials: false   
  }
})

export const config = wagmiAdapter.wagmiConfig